import React from 'react';

import I18n from '../../../../../../i18n';

interface IProp {
  coordinates: string
}

class SampleGpsComponent extends React.Component<IProp, {}> {

    render(): JSX.Element {
        return (
            <div>
                <a target="_blank" href={`http://www.google.com/maps/place/${this.props.coordinates}`}>{I18n.l('common.seeInMap')}</a>                       
            </div>
        )}
};

export default SampleGpsComponent;
